'use client';

import { WaitlistForm } from "@/components/auth-related/waitlist-form";
import { isSignupsEnabled } from "@/lib/auth/mode";
import Image from 'next/image';
import Link from 'next/link';
import { redirect } from 'next/navigation';
import { useTheme } from 'next-themes';
import { useSyncExternalStore, Suspense } from 'react';

function WaitlistContent() {
    const { resolvedTheme } = useTheme();
    const mounted = useSyncExternalStore(() => () => {}, () => true, () => false);

    if (isSignupsEnabled()) {
        redirect("/auth/sign-up");
    }

    return (
        <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
            <div className="flex w-full max-w-sm flex-col gap-6">
                <Link href="/" className="flex items-center gap-2 self-center font-medium">
                    {mounted && (
                        <Image
                            src={resolvedTheme === 'dark' ? '/images/logo-dark.webp' : '/images/logo.webp'}
                            alt="Logo"
                            width={120}
                            height={48}
                            style={{ height: 'auto' }}
                        />
                    )}
                </Link>
                <WaitlistForm />
            </div>
            <div
                aria-hidden="true"
                className="-z-10 pointer-events-none absolute bg-gradient-hero"
                style={{
                    inset: "1px",
                    height: "calc(-2px + 100vh)",
                    width: "calc(100% - 2px)",
                    transform: "rotate(180deg)"
                }}
            ></div>

            <div
                aria-hidden="true"
                className="-z-10 pointer-events-none absolute left-0 top-0 w-full bg-gradient-overlay"
                style={{
                    height: "100vh",
                    transform: "rotate(180deg)"
                }}
            ></div>
        </div>
    );
}

export default function Page() {
    return (
        <Suspense fallback={<div className="flex min-h-svh w-full items-center justify-center">Loading…</div>}>
            <WaitlistContent />
        </Suspense>
    );
}
